import { NavLink } from "react-router-dom";
import { Home, CalendarDays, Radio, Map, Heart } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Início", icon: Home },
  { to: "/programacao", label: "Programa", icon: CalendarDays },
  { to: "/agora", label: "Agora", icon: Radio },
  { to: "/mapa", label: "Mapa", icon: Map },
  { to: "/a-minha-feira", label: "A minha Feira", icon: Heart },
];

export default function BottomNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-black/10 pb-safe" aria-label="Navegação rápida">
      <ul className="grid grid-cols-5">
        {ITEMS.map(({ to, label, icon: Icon }) => (
          <li key={to}>
            <NavLink to={to} end={to === "/"} data-testid={`bottom-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `flex flex-col items-center justify-center gap-1 min-h-[60px] text-[10.5px] font-semibold whitespace-nowrap ${isActive ? "text-[var(--leaf)]" : "text-slate-600"}`}>
              <Icon className="h-5 w-5" aria-hidden />{label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
